export const ATTRIBUTE_CARD_DEFAULT_WIDTH = 261;

export const CSS_TABLE_COLUMNS = "columns";
export const DEFAULT_QUERY_SIZE = 20;
export const EMPTY_URL = "centric:";

/** limit to the number of results that will be considered in queries before stopping */
export const QUERY_COUNT_LIMIT = 10000;

/** limit to the number of results that can be returned to the client before stopping */
export const QUERY_RESULT_LIMIT = 5000;

/** request constants */
export const CREW_SCOPE = "Crew.Scope";
export const DEP_CARD_ID = "Dep.Card.Id";
export const DEP_PATH = "Dep.Path";
export const FMT_AC_RIGHTS = "Fmt.AC.Rights";
export const FMT_ATTR_INFO = "Fmt.Attr.Info";
export const FMT_ATTR_LIST = "Fmt.Attr.List";
export const FMT_COMPLETE = "Fmt.Complete";
export const FMT_COMPLETE_MAX = "Fmt.Complete.Max";
export const FMT_CREW = "Fmt.Crew";
export const FMT_VERSION = "Fmt.Version";
export const FMT_VERSION_VALUE = 2;	// support for time in milliseconds rather than seconds
export const MODULE = "Module";
export const MODULE_DATA_STORE = "DataStore";
export const MODULE_SEARCH = "Search";
export const OPERATION = "Operation";
export const OPERATION_COUNT_XML = "CountByXML";
export const OPERATION_QUERY_URL = "QueryByURL";
export const OPERATION_QUERY_XML = "QueryByXML";
export const OUTPUT_JSON = "OutputJSON";
export const PARAMETER = "Parameter";
export const PRV_URL = "Prv.URL";
export const QRY_LIMIT_BEGIN = "Qry.Limit.Begin";
export const QRY_LIMIT_END = "Qry.Limit.End";
export const QRY_LIMIT_FILTER = "Qry.Limit.Filter";
export const QRY_LIMIT_LIST = "Qry.Limit.ListRef";
export const QRY_LIMIT_PATH = "Qry.Limit.Path";
export const QRY_URL = "Qry.URL";
export const QRY_VALUE_ATTR = "Qry.Value.Attr";
export const QRY_VALUE_CNL_LIMIT = "Qry.Value.CnlsLimit";
export const QRY_VALUE_EMPTY_ONLY = "Qry.Value.EmptyOnly";
export const QRY_VALUE_INDEX = "Qry.Value.Index";
export const QRY_VALUE_NODE = "Qry.Value.Node";
export const QRY_VALUE_PATH = "Qry.Value.Path";
export const QRY_VALUE_RESOLVE_VALUE_REFS = "Qry.Value.ResolveValueRefs";
export const QRY_XML = "Qry.XML";

export const REQUEST_URL_OMIT_PARAMS = [
	FMT_COMPLETE,
	FMT_COMPLETE_MAX,
	QRY_LIMIT_BEGIN,
	QRY_LIMIT_END,
	QRY_LIMIT_FILTER,
	QRY_LIMIT_PATH,
];


/** custom view constants */
export const CHART_HEIGHT_SMALL = "1";
export const CHART_HEIGHT_MEDIUM = "2";
export const CHART_HEIGHT_LARGE = "3";

export const FILTER_POSITION_COLUMN = "column";
export const FILTER_POSITION_TOOLBAR = "toolbar";

export const GALLERY_HEADERS_PER_GROUP = "Group";
export const GALLERY_HEADERS_PER_PAGE = "Page";
export const GALLERY_TEMPLATE_BASIC = "Basic";
export const GALLERY_TEMPLATE_RIGHT = "Right";

export const PREFERENCE_DEFAULT = "Default";
export const RESOURCE_DEFAULT_VALUE = "DefaultValue";

export const TABLE_HEIGHT_SMALL = "1";
export const TABLE_HEIGHT_MEDIUM = "2";
export const TABLE_HEIGHT_LARGE = "3";
export const TABLE_HEIGHT_AUTO = "4";
export const TABLE_HEIGHT_FULL = "5";

export const TABLE_DEFAULT_FREEZE_COLUMNS = 1;
export const TABLE_MAX_FREEZE_COLUMNS = 8;
export const TABLE_NO_SWIPE_TO_GO_BACK = "csi-no-swipe-to-go-back";


/** Metrics position index after all classifiers. Supposed to be large integer, greater than max number of classifiers */
export const SLICER_MAX_METRICS_POS = 9999;

/** Slicer color highlighting conditions */
export const SLICER_HL_LESS = "lt";
export const SLICER_HL_LESS_EQ = "lte";
export const SLICER_HL_BETWEEN = "between";
export const SLICER_HL_GREATER = "gt";
export const SLICER_HL_GREATER_EQ = "gte";
export const SLICER_HL_OTHER = "other";

